import styles from './styles.module.scss'
import Link from 'next/link'
import { intl } from 'src/i18n'

export const FormButton = () => {
  return (
    <Link
      href='https://docs.google.com/forms/d/e/1FAIpQLSc2DNV64z0TK4huBnNdWLaER96Y91f-RdGIqC5OE7-R8ELovg/viewform?usp=sf_link'
      passHref
    >
      <div className={styles.button}>
        {/*rel='noopener noreferrer nofollow' target='_blank'*/}
        {intl.t('components.formBanner.button')}
      </div>
    </Link>
  )
}
